import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {Chart} from "chart.js";

@Component({
  selector: 'app-table-questionnaires',
  templateUrl: './table-questionnaires.component.html',
  styleUrls: ['./table-questionnaires.component.css']
})
export class TableQuestionnairesComponent implements OnInit, OnDestroy {
  //
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  subscription1: Subscription;
  subscription2: Subscription;
  //subscription3: Subscription;
  subscription5: Subscription;
  title = 'Questionari globali'; // titolo generale
  destination = 'general-status';
  // ******************************************************************************************************************
  // inizializzazione per i doughnut charts sul numero di utenti per malattia
  // ******************************************************************************************************************
  public colorsOptions = [{
    backgroundColor: [
      '#ffc0cb',
      '#336699',
    ],
    hoverbackgroundColor: [
      '#c46200',
      '#214262',
    ]
  }];
  public doughnutChartOptions = {
    legend: {
      onHover: (event: MouseEvent, legendItem: Chart.ChartLegendLabelItem) => {
        // tslint:disable-next-line:max-line-length
        if (legendItem.text.length > 0 && (legendItem.text === 'Donne' || legendItem.text === 'Uomini')) {
          this.setHoverVariable();
        } else {
          this.unsetHoverVariable();
        }
      },
      display: true,
      position: 'top',
      align: 'left',
      textDirection: 'ltr',
      labels: {
        usePointStyle: true,
        fontColor: '#006192',
        fontSize: 18,
        fontFamily: 'Helvetica',
      }
    },
    cutoutPercentage: 70,
    tooltips: {
      content: '{pathology}: {number}',
      backgroundColor: '#1c1c1c',
      titleColor: '#f0d7f7',
      bodyFontSize: 18,
      titleFontSize: 18,
      cornerRadius: 5,
      caretPadding: 10
    }
  };
  // hover
  isHovered = false;
  public totalPatientsD = 0;
  public headElements = ['gender', 'number'];
  public elements: any = [
    {gender: '', number: ''},
    {gender: '', number: ''},
    {total: ''}
  ];
  public elementsD: any = [
    {gender: '', number: ''},
    {gender: '', number: ''},
    {total: ''}
  ];
  public doughnutChartLabels = ['Donne', 'Uomini'];
  public doughnutChartData = []; // sono i dati che vanno presi dal database tramite delle richieste
  public doughnutChartDataDoctor = []; // sono i dati che vanno presi dal database, riferiti ai pazienti del singolo medico
  public doughnutChartType = 'doughnut';

  constructor(private store: Store<AppState>,
              private doctorService: DoctorService) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState); }

  ngOnInit(): void {
    this.subscription5 = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      this.retrievedata4();
    });
  }
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    //this.subscription3.unsubscribe();
    this.subscription5.unsubscribe();
  }

  retrievedata4() {
    this.subscription1 = this.doctorService.getQuestionnairesTotalFemale().subscribe(
      compiledQuestionnaires => {
        localStorage.setItem('FQuestionnaires', compiledQuestionnaires.toString());
        this.doughnutChartDataDoctor.push(compiledQuestionnaires);
        this.elementsD[0].gender = 'Donne';
        this.elementsD[0].number = compiledQuestionnaires.toString();
        this.totalPatientsD = +parseInt(compiledQuestionnaires.toString());
        console.log('4');
        this.retrievedata5();
      }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });
  }

  retrievedata5() {
    // prendo dal database il numero di tutti i pazienti che soffrono di colite ulcerosa del singolo dottore
    this.subscription2 = this.doctorService.getQuestionnairesTotalMale().subscribe(
      compiledQuestionnaires => {
        localStorage.setItem('MQuestionnaires', compiledQuestionnaires.toString());
        this.doughnutChartDataDoctor.push(compiledQuestionnaires);
        this.elementsD[1].gender = 'Uomini';
        this.elementsD[1].number = compiledQuestionnaires.toString();
        this.totalPatientsD += parseInt(compiledQuestionnaires.toString());
        console.log('5');
        //this.retrievedata6();
      }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });
  }


  // set hovered variable of Never Logged
  setHoverVariable(): void {
    this.isHovered = true;
  }
  // unset hovered variable of Never Logged
  unsetHoverVariable(): void {
    this.isHovered = false;
  }
}
